import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Modal from '@mui/material/Modal';
import { Chip, Stack } from '@mui/material';
import PDFViewButton from '../FileManager/PDFViewButton';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: "60%",
  maxWidth: 550,
  minWidth: 300,
  maxHeight: 650,
  p: 3,
  borderRadius: 1,
  boxShadow: 24,
  overflowX: "auto",
};

export default function ProjectDetailModal({ open, handleClose, data }) {
  // const [documents, setDocuments] = useState([data.items]);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={1}>
            <Typography variant='h4'>Project Details</Typography>
            <Typography variant='h6'><b>Name: </b>{data.name ? data.name : ""}</Typography>
            <Typography variant='h6'><b>Sponsor: </b>{data.sponsor ? data.sponsor: ""}</Typography>
            <Typography variant='h6'><b>Sponsor Contact: </b> {data.sponsor_contact ? <Link variant='body' href={`mailto:${data.sponsor_contact}`}> {data.sponsor_contact}</Link>  : "" }</Typography>
            <Typography variant='h6'><b>Size: </b>{data.capacity ? data.capacity : ""}</Typography>
            <Typography variant='h6'><b>Project Description: </b>{data.description ? data.description : ""}</Typography>
            <Typography variant='h6'><b>Tags: </b></Typography>
            <Box sx={{display: "flex", gap: 1, maxWidth: 500, flexWrap: "wrap"}}>
              {data.tags?.map((tag) => ( 
                  <Chip label={tag.name} key={tag.name}/>
              ))}
            </Box>

            <Typography variant='h6'><b>Documents: </b></Typography>
            {data.documents.map((document, i) => (
              <PDFViewButton
                key={"document-" + i}
                file={document}
              />
            ))}
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}